import Swiper from 'swiper/bundle';

$(function () {
    const initializeCarousel = (carousel: JQuery<HTMLElement>) => {
        if (carousel && carousel.length) {
            const carouselAutoplay = carousel.attr('data-autoplay')?.toLowerCase() === 'true';

            // Rather then determining the module id manually, we can add a data-module-id into the template
            // But it is not supported yet.
            const carouselDnnContainer = carousel.closest('.DnnModule').get(0);
            let carouselDnnContainerSelector = '';
            for (let j = 0; j < carouselDnnContainer.classList.length; j++) {
                carouselDnnContainerSelector += `.${carouselDnnContainer.classList[j]}`;
            }

            new Swiper(`${carouselDnnContainerSelector} .carousel-slider`, {
                autoplay: carouselAutoplay && {
                    delay: 6000
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                init: true,
                loop: true
            });

            carousel.attr('data-initialized');
        }
    };

    const initializeCarousels = (selector: string) => {
        if (!selector.length) {
            return
        }

        const carousels = $(selector);

        if (carousels && carousels.length > 0) {
            for (let i = 0; i < carousels.length; i++) {
                initializeCarousel($(carousels[i]));
            }
        }
    };

    // Listeners
    document.addEventListener('RHA:InitializeCarouselLazyLoaded', function (customEvent: CustomEvent) {
        if (!customEvent?.detail?.carouselSelector) {
            return
        }

        initializeCarousels(`${customEvent.detail.carouselSelector}.carousel-slider:not([data-initialized])`)
    });

    // Init
    initializeCarousels('.carousel-slider:not(.lazy-loaded):not([data-initialized])')
});
